// smartcardBackgrounds.js
export const SMARTCARD_BG_URLS = {
  Silver:
    "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/smartcard%2Fcoremember-smartcard.jpg?alt=media&token=98a82221-f8c5-48cc-9a5a-3460f03a7f81",
  Gold: "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/smartcard%2Fgoldcard.png?alt=media&token=d2fe6e22-fb50-4785-a0f4-9aaac2e32b26",
  Royal:
    "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/smartcard%2Froyalcard.png?alt=media&token=857ee5db-bd0c-47ae-afe5-97321be9c5e8",
  Premium:
    "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/smartcard%2Fpremiumcard.png?alt=media&token=f478ec51-834f-4ebc-9245-f2b0915164ca",
};
